import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, tap } from 'rxjs';

import { FeatureFlagResponse } from '../models/feature-flag-response';
import { FeatureFlag } from '../models/feature-flag.enum';
import { MatSnackBar } from '@angular/material/snack-bar';

type _FeatureFlagKeys = keyof FeatureFlagResponse;

export type FeatureFlagKeys = {
	[K in _FeatureFlagKeys]: K;
}[_FeatureFlagKeys];

@Injectable({
	providedIn: 'root'
})
export class FeatureFlagService {
	public features!: FeatureFlagResponse;

	constructor(
		protected httpClient: HttpClient,
		private injector: Injector,
		@Inject('environment') private environment: any,
		private snackBar: MatSnackBar
	) {}

	public getFeatureFlags(): Observable<FeatureFlagResponse> {
		return this.httpClient.get<FeatureFlagResponse>(`${this.environment.apiUrl}api/main/GetFeatureflags`).pipe(
			tap((features: FeatureFlagResponse) => {
				const missingFlags = Object.values(FeatureFlag).filter((flag) => !(flag in features));
				//if (missingFlags.length > 0) {
				//	throw new Error(`Missing feature flags from API response: ${missingFlags.join(', ')}`);
				//}
				this.features = features;
			})
		);
	}

	public getFeatureFlagsToManage(refresh: boolean = false): Observable<any[]> {
		return this.httpClient.get<any[]>(
			`${this.environment.apiUrl}api/main/GetFeatureFlagsToManage?refresh=${refresh}`
		);
	}

	public getFeatureFlagsFilters(): Observable<any[]> {
		return this.httpClient.get<any[]>(`${this.environment.apiUrl}api/main/GetFeatureFlagsFilters`);
	}

	public getFeature(flag: FeatureFlag): boolean {
		return this.features[flag] ?? false;
	}

	public enableDisableFlags(flagIds: number[], enabled: boolean): Observable<void> {
		const params = {
			flagIds: flagIds,
			enabled: enabled
		};

		return this.httpClient.post<void>(`${this.environment.apiUrl}api/main/EnableDisableFlags`, params);
	}

	public deleteFlags(flagIds: number[]): Observable<void> {
		const params = {
			flagIds: flagIds
		};

		return this.httpClient.post<void>(`${this.environment.apiUrl}api/main/DeleteFlags`, params);
	}

	public editInsertFlags(flags: any[]): Observable<void> {
		return this.httpClient.post<void>(`${this.environment.apiUrl}api/main/EditInsertFlags`, flags);
	}

	public showSuccess(message: string): void {
		this.snackBar.open(message, 'Close', {
			duration: 3000,
			panelClass: ['snackbar-success'],
			horizontalPosition: 'center',
			verticalPosition: 'bottom'
		});
	}

	public showError(message: string): void {
		this.snackBar.open(message, 'Close', {
			duration: 5000,
			panelClass: ['snackbar-error'],
			horizontalPosition: 'center',
			verticalPosition: 'bottom'
		});
	}

	public;
}
